import React from 'react';
import 'antd/dist/reset.css';
//import  {Moment} from 'moment-timezone';
import dayjs from 'dayjs';

import isoWeek from 'dayjs/plugin/isoWeek';

import Cal from '../../model/Calendar';

import itIT from 'antd/lib/calendar/locale/it_IT';
import enEN from 'antd/lib/calendar/locale/en_GB';


import './Moleskine.css';
// import DailyView from './DailyView';
import { Calendar, CalendarProps, Card } from 'antd';
import Title from './Title';
// import WeeklyView from './WeeklyView';
import RangeView from './RangeView';

import WeeklyView from './WeeklyView';
import { isNullOrUndefined } from '../../utils';
import { useTranslation } from '@nic-react-i18n/core';


dayjs.extend(isoWeek);

//const PREFIX_CLS = 'ant-picker-calendar';

const VIEW_MODE: Record<string, CalendarMode> = {
    year: 'year',
    month: 'month',
    week: 'week',
    day: 'day',
    range: 'range'
};

function noop() { return null; }
/*
export function zerofixed(v: number): string {
    if (v < 10) {
        return `0${v}`;
    }
    return `${v}`;
}
 */
export type CalendarMode = 'month' | 'year' | 'week' | 'day' | 'range' | 'date';

export interface MoleskineType {
    mode: CalendarMode;
    date: dayjs.Dayjs;
    agenda: Cal;
    prefixCls?: string;
    className?: string;
    value?: dayjs.Dayjs;
    defaultValue?: dayjs.Dayjs;
    fullscreen?: boolean;
    dateCellRender?: CalendarProps<dayjs.Dayjs>['fullCellRender']
    monthCellRender?: (date: dayjs.Dayjs) => React.ReactNode;
    dateFullCellRender?: CalendarProps<dayjs.Dayjs>['fullCellRender']
    monthFullCellRender?: (date: dayjs.Dayjs) => React.ReactNode;
    locale?: string;
    style?: React.CSSProperties;
    onPanelChange?: (date: dayjs.Dayjs, mode: CalendarMode) => void;
    onSelect?: (date: dayjs.Dayjs, mode: CalendarProps<dayjs.Dayjs>['onSelect']) => void;
    disabledDate?: (current: dayjs.Dayjs) => boolean;
    baseURI?: string;
    requestCalendar: boolean;
    title?: React.ReactElement<any>;
}

const Moleskine: React.FC<MoleskineType> = (props) => {

    const {locale} = useTranslation()

    const monthCellRender = (value: dayjs.Dayjs) => {

        const {  monthCellRender = noop } = props;
        return (
            monthCellRender(value)

        );
    }

    const __dateCellRender: CalendarProps<dayjs.Dayjs>['fullCellRender'] = (date, info)  => {

        const {  dateCellRender = noop } = props;

        return dateCellRender(date, info)

    }

    const fullCellRenderer: CalendarProps<dayjs.Dayjs>['fullCellRender'] = (date, info)  => {
        switch (info.type) {
            case 'month':
                return monthCellRender(date)
            case 'date':
                return __dateCellRender(date, info)
        }
    }


    const {fullscreen, date, requestCalendar, baseURI} = props;

    // const _monthCellRender = props.monthFullCellRender || monthCellRender;
    // const _dateCellRender = fullCellRenderer

    //const onSelect = props.onSelect;

    const type = VIEW_MODE[props.mode];

    const calendarFormat = (props.mode === 'month' ? 'month': 'year')

    const moleskineTitle = (isNullOrUndefined(props.title) ?
        ( <Title locale={locale} requestCalendar={requestCalendar} baseURI={baseURI}/> ) :
        props.title);

    //console.log('Moleskine: ', moleskineTitle, type)


    return (
        <div className="margin-top-5">
            <Card>

                {moleskineTitle}

                { (type !== 'day' &&  type !== 'week' && type !== 'range' && (
                        <>

                            <Calendar
                                fullscreen={fullscreen}
                                cellRender={fullCellRenderer}
                                value={date}
                                locale={locale === 'it' ? itIT: enEN}
                                onPanelChange={props.onPanelChange}
                                mode={calendarFormat}
                                headerRender={({ value, type, onChange, onTypeChange }) => {return <></>}}
                            />

                        </>
                    ))  || ( type !== 'week' && <RangeView {...props} /> )
                    || (<WeeklyView {...props} />)
                }
            </Card>
        </div>
    );
}

export default Moleskine